import { render, staticRenderFns } from "./LabValueFieldReadonly.vue?vue&type=template&id=75e0a60b&scoped=true"
import script from "./LabValueFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./LabValueFieldReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e0a60b",
  null
  
)

export default component.exports